import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {VoiceMacro} from "@allaihealth/util";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatOption, MatSelect} from "@angular/material/select";
import {NoteDescriptor, PostVisitCategories} from "@allaihealth/notes";
import {YesNoData, YesNoDialogComponent} from "../yes-no-dialog/yes-no-dialog.component";
import {firstValueFrom} from "rxjs";

/** Simple dialog to show yes/no questions */
@Component({
	selector: 'app-macro-dialog',
	imports: [
		MatDialogModule,
		MatButtonModule,
		MatInput,
		FormsModule,
		MatFormField,
		MatSelect,
		MatLabel,
		MatOption
	],
	templateUrl: './macro-dialog.component.html',
	styleUrl: './macro-dialog.component.scss'
})
export class MacroDialogComponent implements OnInit {
	protected sections:NoteDescriptor[] = PostVisitCategories;
	protected shortNames = new Set(["CC","HPI","Asmt","Pl","PE"]);

	constructor(private dialog:MatDialog, private dialogRef:MatDialogRef<MacroDialogComponent>,
	            @Inject(MAT_DIALOG_DATA) public data:VoiceMacroData) {
	}

	ngOnInit():void {
		this.dialogRef.updateSize('800px');
		this.dialogRef.disableClose = true;
		this.sections = this.sections.filter(section => this.shortNames.has(section.shortName));
	}

	private unchanged() {
		return this.data.macro.phrase == this.data.original.phrase
			&& this.data.macro.section == this.data.original.section
			&& this.data.macro.substitution == this.data.original.substitution;
	}
	protected async cancelDialog() {

		if(this.unchanged()) {
			this.dialogRef.close();
		} else {

			let title = "Discard changes?";
			let message = "Your unsaved changes will be lost.";
			if(this.data.macro.id?.trim().length == 0) {
				title = "Discard new macro?";
				message = "The macro will not be saved.";
			}

			const value = await firstValueFrom(this.dialog.open<YesNoDialogComponent, YesNoData, boolean>(
				YesNoDialogComponent, {
					data: {
						yes: "Discard",
						no: "Cancel",
						title,
						message,
						disableClose: true
					}
				}).afterClosed());

			if(value) {
				this.dialogRef.close();
			}
		}
	}

	protected hasAllValues() {
		return this.data.macro.phrase?.trim().length > 0
		&& this.data.macro.substitution?.trim().length > 0
		&& this.data.macro.section?.trim().length > 0;
	}
}

export interface VoiceMacroData {
	title:string;
	ok:string;
	cancel:string;
	macro:VoiceMacro;
	original:VoiceMacro;
}



